/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Learn_C1_TitleInputs */

const en_cad_learn_c1_title = /** @type {(inputs: Cad_Learn_C1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first drawing`)
};

/**
* | output |
* | --- |
* | "Your first drawing" |
*
* @param {Cad_Learn_C1_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_learn_c1_title = /** @type {((inputs?: Cad_Learn_C1_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Learn_C1_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_learn_c1_title(inputs)
});
export { cad_learn_c1_title as "cad.learn.c1_title" }